import axios from "axios"
import {
    mapChannelList,
    mapCurrencyList,
    defaultChannelsList,
    defaultCurrenciesList
} from "src/utils/CONSTANT";

const SETTINGS_BASE_URI = "/v1/settings/query";
const SETTINGS_URIS_PREFIX = "/v1/settings/query?page=1&pageSize=30&code=";
const SETTINGS_URIS = {
    GET_PAYMENT_CHANNELS: `${SETTINGS_URIS_PREFIX}PAYMENT_CHANNEL`,
    GET_PAYMENT_CURRENCIES: `${SETTINGS_URIS_PREFIX}PAYMENT_CURRENCY_TYPE`,
    GET_TDG_ACTIVITY_TOGGLE: `${SETTINGS_URIS_PREFIX}TDG_ACTIVITY_TOGGLE`,
};

export default {
  getPaymentChannels(returnDefault) {
    return new Promise((resolve, reject) => {
      axios.get(SETTINGS_URIS.GET_PAYMENT_CHANNELS).then((res) => {
        var channels = [];
        try {
          const list = res.data.items.list.map((data) => data.settingCode);
          channels = mapChannelList(list);
        } catch (e) {
          console.log("error: " + e);
        }
        if ((!channels || channels.length == 0) && returnDefault) {
          channels = defaultChannelsList;
        }
        resolve(channels || []);
      });
    });
  },

  getPaymentCurrencies(returnDefault) {
    return new Promise((resolve, reject) => {
      axios.get(SETTINGS_URIS.GET_PAYMENT_CURRENCIES).then((res) => {
        var currencies = [];
        try {
          const list = res.data.items.list.map((data) => data.settingCode);
          currencies = mapCurrencyList(list);
        } catch (e) {
          console.log("error: " + e);
        }
        if ((!currencies || currencies.length == 0) && returnDefault) {
          currencies = defaultCurrenciesList;
        }
        resolve(currencies || []);
      });
    });
  },

  async getTdgActivityToggle() {
    try {
      const resp = await axios.get(SETTINGS_URIS.GET_TDG_ACTIVITY_TOGGLE);
      return resp.data;
    } catch (error) {
      return null;
    }
  },

  async getSettingsValueForCode(code) {
    try {
      const resp = await axios.get(`${SETTINGS_URIS_PREFIX}${code}`);
      return resp.data.items.list[0].settingValue;
    } catch (error) {
      return null;
    }
  },

  async getSettings(q = {}) {
    try {
      const queryParams = {
        page: 1,
        pageSize: 30,
        ...q,
      };
      const searchParams = new URLSearchParams(queryParams);
      const url = `${SETTINGS_BASE_URI}?${searchParams.toString()}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return null;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/settings.js